import React from "react"
import { Box } from "rebass"
import Scrollbar from "react-scrollbars-custom"
import { SizeMe } from "react-sizeme"
import { motion } from "framer-motion"

import HoverCursor from "../images/cursor-hover.png"
import Pattern from "../images/fill.svg"
import FloatingBox from "./floating-box"
import Cloud from "./cloud"
import ExcerptContent from "./excerpt-content"

const GreenCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ bottom: [-40, 100], left: 0 }}
  >
    <motion.div
      animate={{ x: "100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#00FF1D" />
    </motion.div>
  </Box>
)

const Excerpt = () => (
  <SizeMe monitorHeight>
    {size => (
      <Box
        sx={{
          color: "text",
          position: "relative",
        }}
      >
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{
            y: 40,
            x: 70,
          }}
        />
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{
            y: 500,
            x: 300,
          }}
        />
        <GreenCloud />
        <Scrollbar
          thumbYProps={{
            renderer: props => {
              const { elementRef, style, ...restProps } = props
              return (
                <div
                  {...restProps}
                  ref={elementRef}
                  style={{
                    ...style,
                    width: 60,
                    height: 60,
                    borderRadius: 0,
                    background: "white",
                    borderTop: "3px solid black",
                    borderBottom: "2px solid black",
                    cursor: `url(${HoverCursor}), auto`,
                  }}
                  className="tHuMbY"
                />
              )
            },
          }}
          minimalThumbYSize={60}
          maximalThumbYSize={60}
          trackYProps={{
            renderer: props => {
              const { elementRef, style, ...restProps } = props
              return (
                <span
                  {...restProps}
                  style={{
                    ...style,
                    width: 60,
                    backgroundColor: "transparent",
                    backgroundImage: `url('${Pattern}')`,
                    backgroundSize: "60px auto",
                    boxShadow: "inset 0 0 0 2px white",
                    borderLeft: "2px solid #000",
                    borderRadius: 0,
                    top: 0,
                    height: "100%",
                  }}
                  ref={elementRef}
                  className="trackY"
                />
              )
            },
          }}
          style={{ width: "100%" }}
        >
          <Box variant="excerptWrap" p={4}>
            <Box variant="excerptInner">
              <ExcerptContent />
            </Box>
          </Box>
        </Scrollbar>
      </Box>
    )}
  </SizeMe>
)

export default Excerpt
